/**
 * Record pages that switched the working facility to their own record's facility (a picklist or transfer opened by
 * link under another facility). The Hub sends a record page home when the facility changes under it; one that asked
 * for the change itself stays open on its record.
 */
const switchedFor = new Map<string, number>();

/** The page at `pathname` is about to switch the facility to `facilityId`, the facility its record belongs to. */
export const switchFacilityForRecord = (pathname: string, facilityId: number) => {
  switchedFor.set(pathname, facilityId);
};

/** The facility the page at `pathname` switched to for its record, if it did. */
export const recordSwitchedTo = (pathname: string): number | undefined => switchedFor.get(pathname);
